import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, CircularProgress, Grid } from "@mui/material";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import useQueryParams from "../../hooks/use-query-params";
import request from "../../utils/request";
import Icon from "../../components/icon";
import Flex from "../../components/flex";
import azure from "../../assets/icons/azure";
import { useAuth } from "../../components/providers/auth-context";
import { getAzureRedirectUrl } from "./utils";

const H1 = styled.h1`
    font-size: 22px;
    font-weight: 500;
    color: ${({ theme }) => theme.palette.primary.main};
`;

const Span = styled.span`
    font-size: 16px;
    font-weight: 300;
    opacity: 0.35;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const AzureOauth = () => {
    const query = useQueryParams();
    const navigate = useNavigate();
    const { idToken } = useAuth();
    const called = React.useRef(false);

    const integrateMethod = async () => {
        if (called.current) return;
        called.current = true;

        const code = query.get("code");
        const state = query.get("state");

        if (!code) {
            navigate("/integrations");
            return;
        }

        if (state !== idToken?.jwt?.sid) {
            navigate("/integrations/failure/azure");
            return;
        }

        try {
            await request(
                `/api/azure/oauth/callback?code=${encodeURIComponent(
                    code
                )}&state=${encodeURIComponent(state)}&redirect_uri=${encodeURIComponent(
                    getAzureRedirectUrl()
                )}`
            );
            localStorage.setItem("cidt", new Date().valueOf().toString());
            navigate("/integrations/success/azure");
        } catch (e) {
            navigate("/integrations/failure/azure");
        }
    };

    React.useEffect(() => {
        if (idToken) {
            integrateMethod();
        }
    }, [idToken]);

    return (
        <>
            <Helmet>
                <title>Adadot - Finalising Azure Integration</title>
            </Helmet>
            <Box mt={10}>
                <Grid
                    container
                    spacing={3}
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Grid item>
                        <Icon svg={azure} width="250px" height="auto" />
                    </Grid>
                    <Grid item style={{ textAlign: "center" }}>
                        <H1>Plugging in Azure</H1>
                        <Span>You will be redirected momentarily</Span>
                    </Grid>
                    <Grid item style={{ marginTop: "40px" }}>
                        <Flex justifyContent="center">
                            <CircularProgress size={50} />
                        </Flex>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
};

export default AzureOauth;
